import { UI_TEXT } from '@/shared/languages';
import { ContentColumn } from './content-column';
import { ScreenShell } from './screen-shell';

/**
 * 라우트 loader 에러 (가드의 critical throw, schema parse 에러 등) catch — 디자인 정합 fallback.
 * RR 의 `ErrorBoundary` 로 등록. React render 에러는 `shared/error` 의 ErrorBoundary 가 별도 catch.
 */
export function RouteError() {
  return (
    <ScreenShell>
      <ContentColumn as="main" className="m-auto space-y-4 text-center">
        <h1 className="text-lg font-semibold">{UI_TEXT.ERROR_CRITICAL_TITLE}</h1>
        <p className="text-sm text-muted-foreground">{UI_TEXT.ERROR_CRITICAL_DESCRIPTION}</p>
      </ContentColumn>
    </ScreenShell>
  );
}
